/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {ControlPointService} from '../../../../services/features/control-point.service';
import {PlanModelService} from '../../../../../common/service/plan-model.service';
import {MapToolsService} from '../../../../services/map-tools.service';
import {EsriModuleService} from '../../../../esri-nlr/services/esri-module.service';
import {ToolServiceInterface} from './tool-service-interface';
import {first} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ControlPointConstructionToolService implements ToolServiceInterface {
    title = 'ControlPointConstructionToolService';

    constructor(
        private controlPointService: ControlPointService,
        private esriModuleService: EsriModuleService,
        private mapToolsService: MapToolsService,
        private planModelService: PlanModelService
    ) {}

    create(attributes: any) {
        console.debug(`${this.title} : create`);
        return this.mapToolsService.activate('CONSTRUCTION_TOOLS_CONTROL_POINT', () => {
            this.createControlPoint(attributes).pipe(first()).subscribe();
        });
    }

    private createControlPoint(attributes: any) {
        console.debug(`${this.title} - createControlPoint`);

        const pointGeometry = new this.esriModuleService.geometry.Point(attributes.x, attributes.y);
        pointGeometry.spatialReference = new this.esriModuleService.SpatialReference(this.planModelService.getSpatialReference());

        const pointAttributes = {};

        for (const [key, value] of Object.entries(attributes) as any[]) {
            if (value && typeof value === 'object') {
                pointAttributes[key] = value.id;
            } else {
                pointAttributes[key] = value;
            }
        }

        const pointGraphic = new this.esriModuleService.Graphic(pointGeometry);
        pointGraphic.attributes = pointAttributes;
        pointGraphic.attributes.visible = 'YES';

        return this.controlPointService.create(pointGraphic);
    }
}
